import $ = require('jquery');
import l10n from '../util/l10n';
import AppRegistry from '../AppRegistry';
import diyLightTheme = require('../material-ui/diyLightTheme');
import ModulWithImage from './ModulWithImage';
import ModuleInlineEditor from 'diy/module/common/js/ModuleInlineEditor';
import {ImageWithTextModuleData} from './image/interfaces';
import {setUndoState, setRedoState, setCurrentTab} from '../module-action-bar/index';
import {
    EditViewTextBasics,
    EditViewTextFormat
} from './image/EditViewText';

function getStore() {
    return AppRegistry.getStoreProvider().getStore();
}

interface CommandListener {
    (this: {state: number}): void;
}

export default class ModulTextWithImage extends ModulWithImage {
    helpArticleId = 'textwithimage';

    inlineEditor: ModuleInlineEditor = null;
    hasText = true;
    data: ImageWithTextModuleData;

    private ckEditorPromise: Promise<CKEditor>;
    private ckEditorPromiseResolve: (ckEditor: CKEditor) => void;

    constructor(moduleId: number) {
        super(moduleId);
        this.ckEditorPromise = new Promise<CKEditor>((resolve, reject) => {
            this.ckEditorPromiseResolve = resolve;
        });
    }

    getCKEditorPromise() {
        return this.ckEditorPromise;
    }

    loadData(data: ImageWithTextModuleData) {
        this.data = data;
        this.data.moduleText = this.getContentElement().querySelector('.textwrapper').innerHTML;
    }
    /**
     * @override
     * purely for typing purposes
     */
    getData() {
        return this.data;
    }

    /** @override */
    getActionBarTabs() {
        const tabs = super.getActionBarTabs();
        tabs.push(
            {
                label: l10n('module.text.tabs.basic'),
                content: this.getConnectedComponent(EditViewTextBasics)
            },
            {
                label: l10n('module.text.tabs.advanced'),
                content: this.getConnectedComponent(EditViewTextFormat)
            }
        );
        return tabs;
    }

    onOpenTracking() {
        if (!this.getIsNew()) {
            let self = this;
            $(document).on('diy-text-editor-clicked', (ev, dat) => {
                /**
                 * Make some SiteCatalyst tracking
                 */
                $(document).trigger('diy-editor-makeWebsiteFit', {
                    'condition': 'Tried',
                    'name': 'Content',
                    'otherData': self.moduleType
                });
            });
        }
    }

    initCKEditor(element: HTMLElement) {
        this.inlineEditor = new ModuleInlineEditor(this, element);

        this.inlineEditor.startEditing({
            'diy-moduleType': this.moduleType,

            // this setting is primary used for setting the z-index
            // of CKEditor dialogs, and these should be the same as
            // standard Material UI dialogs zIndex
            baseFloatZIndex: diyLightTheme.zIndex.dialog,
            allowedContent: !this.getData().supports.textSanitizeHtml,
            toolbarStartupExpanded: true,
            sharedSpaces: {
                top: 'inline-editor-toolbar-' + this.moduleId
            },
            toolbar: 'ImageWithText',
            toolbar_ImageWithText: this.getCkeditorToolbarConfig(),
            format_tags: 'p;h1;h2;pre',
            pasteFromWordRemoveFontStyles: false,
            pasteFromWordRemoveStyles: false,
            hideToolbar: true
        });

        const switchToText = () => {
            const store = getStore();
            store.dispatch(setCurrentTab({nextTab: 3, currentTabWhitelist: [0, 1, 2]}));
        };

        this.inlineEditor.editor.on('instanceReady', () => {
            this.ckEditorPromiseResolve(this.inlineEditor.getEditor());

            const store = getStore();

            this.inlineEditor.editor.getCommand('undo').on('state', function() {
                store.dispatch(setUndoState({enabled: this.state !== CKEDITOR.TRISTATE_DISABLED}));
            } as CommandListener);

            this.inlineEditor.editor.getCommand('redo').on('state', function() {
                store.dispatch(setRedoState({enabled: this.state !== CKEDITOR.TRISTATE_DISABLED}));
            } as CommandListener);

            this.inlineEditor.editor.on('destroy', () => {
                element.removeEventListener('mousedown', switchToText);
                element.removeEventListener('touchend', switchToText);
            });
            element.addEventListener('mousedown', switchToText);
            element.addEventListener('touchend', switchToText);
        });
    }

    hide() {
        if (this.inlineEditor) {
            this.inlineEditor.stopEditing();
        }
        super.hide();
    }

    runSaveAction() {
        if (!this.getIsNew()) {
            /**
             * Make some SiteCatalyst tracking
             */
            $(document).trigger('diy-editor-makeWebsiteFit', {
                'condition': 'Applied',
                'name': 'Content',
                'otherData': this.moduleType
            });
        }
        super.runSaveAction();
    }

    /**
     * @override
     */
    getSaveData() {
        const data = super.getSaveData();
        return Object.assign(data, {
            text: this.inlineEditor.getHtmlData()
        });
    }

    /**
     * @override
     */
    close(userClose?: boolean, cancelEdit?: boolean, isSaving?: boolean, isUserAction?: boolean) {
        this.inlineEditor.stopEditing();
        super.close(userClose, cancelEdit, isSaving, isUserAction);
    }

    private getCkeditorToolbarConfig() {
        return [
            ['FontSize'],
            ['Undo', 'Redo'],
            ['Format'],
            ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'],
            ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
            ['DiyLink', 'DiyUnlink'],
            ['NumberedList', 'BulletedList'],
            '/',
            ['Outdent', 'Indent'],
            ['StyleButton', 'DiyTextColor'],
            ['PasteText', 'RemoveFormat'],
            ['Sourcedialog', 'PasteFromWord', 'SelectAll'],
            // XXX Including support for table, even if no controls in Action Bar
            // because users wants to keep copy-pasted tables, and CKEditor should
            // not strip them away
            '/',
            ['Table'], ['TableMixed'],
            ['TableInsertRowBefore', 'TableInsertRowAfter', 'TableDeleteRow'],
            ['TableInsertColumnBefore', 'TableInsertColumnAfter', 'TableDeleteColumn'],
            ['TableSplitVertically', 'TableSplitHorizontally'],
            ['TableMergeRight', 'TableMergeDown', 'TableMerge']
        ];
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulTextWithImage.ts
 **/